// createSlice reducers mutate an Immer draft by design (RTK's recommended
// pattern) - that mutation is what no-param-reassign would otherwise flag.
/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { User } from '@/types';

export type AuthStatus = 'loading' | 'authenticated' | 'unauthenticated';

export interface AuthState {
  // Access token is held in memory only (never localStorage) to limit XSS
  // exposure. The refresh + device cookies (httpOnly) re-establish it on reload.
  accessToken: string | null;
  user: User | null;
  status: AuthStatus;
  isAuthenticated: boolean;
}

const initialState: AuthState = {
  accessToken: null,
  user: null,
  status: 'loading',
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<{ accessToken: string; user: User }>) => {
      state.accessToken = action.payload.accessToken;
      state.user = action.payload.user;
      state.isAuthenticated = true;
      state.status = 'authenticated';
    },
    clearAuth: (state) => {
      state.accessToken = null;
      state.user = null;
      state.isAuthenticated = false;
      state.status = 'unauthenticated';
    },
    setUnauthenticated: (state) => {
      state.accessToken = null;
      state.user = null;
      state.isAuthenticated = false;
      state.status = 'unauthenticated';
    },
  },
});

export const { setAuth, clearAuth, setUnauthenticated } = authSlice.actions;
export default authSlice.reducer;
